import { render, staticRenderFns } from "./huodongtongji.vue?vue&type=template&id=226073b5"
import script from "./huodongtongji.vue?vue&type=script&lang=js"
export * from "./huodongtongji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports